import { useMutation } from 'react-query';
import { network } from 'services/network';
import {
    ICreateMapping,
    ICreateTemplate,
    IDeleteMappingParams,
} from 'components/Dashboards/Portfolio/phasePerformance/manage/manage.types';

const createTemplate = (params) => {
    return network
        .post('api/bo/phaseperformance/createGateTemplate', params)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

const updateTemplate = (params) => {
    return network
        .post('api/bo/phaseperformance/updateGateTemplate', params)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

const createMapping = (params) => {
    return network
        .post('api/bo/phaseperformance/mapToContract', params)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

const deleteTemplate = (templateId) => {
    return network
        .post('api/bo/phaseperformance/deleteGateTemplate', {
            template_id: templateId,
        })
        .then((response) => response.data)
        .catch((error) => {
            throw error;
        });
};

const deleteMapping = (params) => {
    return network
        .post('api/bo/phaseperformance/deleteMapping', params)
        .then((response) => response.data)
        .catch((error) => {
            throw error;
        });
};

const useMutationCreateTemplate = () => {
    return useMutation<unknown, QueryError, ICreateTemplate>((params) => createTemplate(params));
};

const useMutationUpdateTemplate = () => {
    return useMutation<unknown, QueryError, ICreateTemplate>((params) => updateTemplate(params));
};

const useMutationCreateMapping = () => {
    return useMutation<unknown, QueryError, ICreateMapping>((params) => createMapping(params));
};

const useMutationDeleteTemplate = () => {
    return useMutation<unknown, QueryError, number>((templateId) => deleteTemplate(templateId));
};

const useMutationDeleteMapping = () => {
    return useMutation<unknown, QueryError, IDeleteMappingParams>((params) => deleteMapping(params));
};

export {
    useMutationCreateTemplate,
    useMutationUpdateTemplate,
    useMutationCreateMapping,
    useMutationDeleteTemplate,
    useMutationDeleteMapping,
};
